import { useIsDemo } from "../api/auth";
import type { QcResultRead, RecordingMode } from "../api/types";
import ScoreGauge from "./ScoreGauge";
import { InfoTip } from "./Tooltip";
import { sortedDeductions } from "../lib/deductions";

interface Props {
  qc: QcResultRead;
  mode: RecordingMode;
}

export default function ScoreCard({ qc, mode }: Props) {
  const deductions = sortedDeductions(qc.health_notes);
  const demo = useIsDemo();

  return (
    <section className="card score-card">
      <div className="card-head">
        <h3>
          Quality score{" "}
          <InfoTip content="stera Evaluate's 0–100 health score (letter grade A–F). Points are deducted for the issues listed below." />
        </h3>
        {!demo && <span className="badge soft">{mode}</span>}
      </div>

      {qc.is_emulator && (
        <div className="emulator-chip" title="Synthetic emulator capture — fails the QC gate">
          EMULATOR — synthetic, not training data
        </div>
      )}

      <div className="score-card-body">
        <ScoreGauge score={qc.score} grade={qc.grade} />
      </div>

      <div className="health-notes">
        <span className="health-notes-title">Deductions</span>
        {deductions.length === 0 ? (
          <p className="health-clean">
            <span className="health-tick">✓</span> No deductions — clean
          </p>
        ) : (
          <ul className="health-list">
            {deductions.map((d, i) => (
              <li key={i} className="health-item" title={d.raw}>
                <span className="health-minus">−</span>
                <span className="health-text">{d.label}</span>
                {d.points != null && (
                  <span className="health-pts">−{d.points.toFixed(1)}</span>
                )}
                {d.tip && <InfoTip content={d.tip} />}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
